import { useState } from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { VideoUploadForm } from "@/components/VideoUploadForm";
import { ThankYouMessage } from "@/components/ThankYouMessage";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL;

function App() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submissionData, setSubmissionData] = useState(null);

  const handleSubmissionSuccess = (data) => {
    setSubmissionData(data);
    setIsSubmitted(true);
  };

  const handleNewSubmission = () => {
    setIsSubmitted(false);
    setSubmissionData(null);
  };

  return (
    <div className="min-h-screen bg-gradient-hero">
      <Toaster position="top-center" richColors />
      <Header />
      
      <main className="relative">
        {/* Decorative background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute top-40 right-20 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-1/3 w-64 h-64 bg-primary-glow/5 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10">
          <HeroSection />
          
          <section className="pb-20 px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto">
              {isSubmitted ? (
                <ThankYouMessage 
                  submissionData={submissionData} 
                  onNewSubmission={handleNewSubmission}
                />
              ) : (
                <VideoUploadForm onSuccess={handleSubmissionSuccess} />
              )}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default App;
